import React from 'react';
import Icon from '../../../components/AppIcon';

const AlertNotificationBanner = ({ alerts, onAcknowledge, onViewDetails }) => {
  if (!alerts || alerts?.length === 0) {
    return null;
  }

  const criticalAlerts = alerts?.filter(a => a?.alertSeverity === 'critical');
  const highAlerts = alerts?.filter(a => a?.alertSeverity === 'high');

  return (
    <div className="space-y-3 mb-6">
      {criticalAlerts?.map((alert) => (
        <div
          key={alert?.id}
          className="bg-error/10 border-2 border-error rounded-xl p-4 shadow-therapeutic"
          role="alert"
          aria-live="assertive"
        >
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 w-10 h-10 bg-error rounded-full flex items-center justify-center">
              <Icon name="AlertTriangle" size={20} className="text-white" strokeWidth={2.5} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <span className="inline-flex items-center px-2 py-1 rounded-md bg-error text-white text-xs font-bold">
                  CRITICAL
                </span>
                <span className="text-sm font-medium text-foreground">
                  {alert?.dependentName}
                </span>
              </div>
              <p className="text-sm text-muted-foreground mb-2">
                Logged severe symptoms requiring immediate attention
              </p>
              <div className="flex flex-wrap gap-2">
                <button
                  onClick={() => onViewDetails(alert)}
                  className="text-xs font-medium text-error hover:underline focus:outline-none focus:ring-2 focus:ring-error focus:ring-offset-2"
                >
                  View Details
                </button>
                <button
                  onClick={() => onAcknowledge(alert?.id)}
                  className="text-xs font-medium text-muted-foreground hover:text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
                >
                  Acknowledge
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}

      {highAlerts?.map((alert) => (
        <div
          key={alert?.id}
          className="bg-warning/10 border-2 border-warning rounded-xl p-4 shadow-therapeutic"
          role="alert"
          aria-live="polite"
        >
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 w-10 h-10 bg-warning rounded-full flex items-center justify-center">
              <Icon name="AlertCircle" size={20} className="text-white" strokeWidth={2.5} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <span className="inline-flex items-center px-2 py-1 rounded-md bg-warning text-white text-xs font-bold">
                  HIGH SEVERITY
                </span>
                <span className="text-sm font-medium text-foreground">
                  {alert?.dependentName}
                </span>
              </div>
              <p className="text-sm text-muted-foreground mb-2">
                Logged symptoms that need your attention
              </p>
              <div className="flex flex-wrap gap-2">
                <button
                  onClick={() => onViewDetails(alert)}
                  className="text-xs font-medium text-warning hover:underline focus:outline-none focus:ring-2 focus:ring-warning focus:ring-offset-2"
                >
                  View Details
                </button>
                <button
                  onClick={() => onAcknowledge(alert?.id)}
                  className="text-xs font-medium text-muted-foreground hover:text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
                >
                  Acknowledge
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AlertNotificationBanner;